'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PUSH_MODAL_WINDOW = exports.PUSH_MODAL_WINDOW = 'PUSH_MODAL_WINDOW';
var INSERT_MODAL_WINDOW = exports.INSERT_MODAL_WINDOW = 'INSERT_MODAL_WINDOW';
var POP_MODAL_WINDOW = exports.POP_MODAL_WINDOW = 'POP_MODAL_WINDOW';
var SHIFT_MODAL_WINDOW = exports.SHIFT_MODAL_WINDOW = 'SHIFT_MODAL_WINDOW';
var CLEAR_MODAL_WINDOWS = exports.CLEAR_MODAL_WINDOWS = 'CLEAR_MODAL_WINDOWS';
var NEXT_MODAL_WINDOW = exports.NEXT_MODAL_WINDOW = 'NEXT_MODAL_WINDOW';
var PREV_MODAL_WINDOW = exports.PREV_MODAL_WINDOW = 'PREV_MODAL_WINDOW';


//////////////////
// WEBPACK FOOTER
// ./~/redux-promising-modals/lib/ActionTypes.js
// module id = 65
// module chunks = 0